import React, { Component, } from 'react'

import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import PropTypes from 'prop-types'

import './../../styles/css/layout/CCLayout/cc-layout.css'
//
// import './cc_lahout.css'
// import './cc_lahout_320.css'

import { CCActions, CCModals, CCCoins, CCIcon, images} from "./../../cc-imports";
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";

class CCLayout extends Component {

    static propTypes = {
        scrollable : PropTypes.bool
    }

    static defaultProps = {
        scrollable : false
    }

    constructor(props) {
        super(props)
        this.state = {}
        this._openModal=this._openModal.bind(this);
        this._getCoins=this._getCoins.bind(this);
        this._isLoggedIn=this._isLoggedIn.bind(this);
    }

    _openModal(func, source){
        if(this.props.user && this.props.user.user && this.props.user.user.id){
            func();
        }
        else {
            this.props.actions.openSignInModal({source});
        }
    }

    _getCoins(){
        if(this.props.user && this.props.user.user && this.props.user.user.id){
            return this.props.user.user.coins;
        }
        else {
            return 1000;
        }
    }

    _isLoggedIn(){
        if(this.props.user && this.props.user.user && this.props.user.user.id != undefined){
            return true;
        }
        return false;
    }

    render() {

        return (
            <CCErrorBoundary>
            <div style={{flex:1}} >
                <div style={{flex:1}}>
                    <div className={'flex-container header-parent'}>
                        <div className={'flex-container header-inner'}>
                            <div className={'flex-container menu-left-container'}>
                                <CCIcon className={'btn cc-more-icon-xxs mgn-r-2'} analytics={{event:'MoreClicked', params:{loggedIn: this._isLoggedIn()}}} onPress={()=>{this.props.actions.openMoreModal()}} type={'menu'}></CCIcon>
                            </div>

                            <div className={'flex-container'}>
                                <CCIcon className={'btn cc-more-icon-xxs mgn-r-1'} analytics={{event:'EntriesClicked', params:{loggedIn: this._isLoggedIn()}}} onPress={()=>{this._openModal(this.props.actions.openEntriesModal, 'entries')}} type={'trophy'}></CCIcon>
                                <CCIcon className={'btn cc-more-icon-xxs mgn-r-3'} analytics={{event:'NotificationsClicked', params:{loggedIn: this._isLoggedIn()}}}  onPress={()=>{this._openModal(this.props.actions.openNotificationsModal, 'notifications')}}  type={'notification'}></CCIcon>
                                {/*<CCIcon className={'btn cc-more-icon-xxs mgn-r-2'} analytics={{event:'ChatClicked', params:{loggedIn: this._isLoggedIn()}}}  onPress={()=>{this._openModal(this.props.actions.openChatModal, 'chat')}}  type={'chat'}></CCIcon>*/}
                                <div>
                                    <CCCoins loggedIn={this._isLoggedIn()} coins={this._getCoins()}
                                             style  ={{...{marginLeft:'2px', marginRight:'5px'}}}
                                             onCoinsIconPress={()=>{this._openModal(this.props.actions.openTransactionsHistoryModal, 'transactions')}}
                                             onCoinsPress={()=>{this._openModal(this.props.actions.openTransactionsHistoryModal, 'transactions')}}
                                             // onPlusPress={()=>{this._openModal(this.props.actions.openAddCoinsModal, 'AddCoins'
                                             // )}}
                                    ></CCCoins>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{flexGrow: 1}}>
                        <CCModals/>
                        { this.props.children }
                    </div>
                </div>
            </div>
            </CCErrorBoundary>

        )
    }
}


export default connect(state => ({
        user : state.user
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(CCLayout);



// WEBPACK FOOTER //
// ./src/app/layout/CCLayout/CCLayout.js